import { useEffect, useState } from "react";
import { useLogin } from "../../hook/partner/authentication/login.partner.hook";
import { useAuthStore } from "../../store/auth.store";
import { useMe } from "../../hook/partner/authentication/me.partner.hook";
import { PartnerApi } from "../../api/partner.api";
import { NavLink, useParams } from "react-router";
import { useTranslation } from "../../hooks/useTranslation";

function PasswordRecovery() {
  const { t } = useTranslation();
  const { email, code } = useParams();
  useEffect(() => {
    window.document.body.classList.add("auth-bg");
  }, []);

  const [username, setUsername] = useState(email);
  const [password, setPassword] = useState("");
  const [recoveryCode, setRecoveryCode] = useState(code);
  const [error, setError] = useState(null);
  const [step2, setStep2] = useState(code || false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    if (step2) {
      const result = PartnerApi.passwordRecoveryCode({
        username,
        data: {
          password,
          recovery_code: recoveryCode,
        },
      });

      result
        .then((result) => {
          if ("error" in result) {
            setError(result.error);
            return;
          }
          setStep2(null);
          window.location.href = "/";
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      const result = PartnerApi.passwordRecovery(username);

      result
        .then((result) => {
          if ("code" in result && result.code == 401) {
            setError(t("auth.userNotFound"));
            return;
          }
          if ("error" in result) {
            setError(result.error);
            return;
          }
          if ("message" in result) {
            setStep2(result.message);
            return;
          }

          setStep2(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10 card">
              <form
                onSubmit={handleSubmit}
                className="form w-100"
                noValidate="novalidate"
                id="kt_sign_in_form"
                data-kt-redirect-url="index.html"
                action="#"
              >
                <div className="text-center mb-11">
                  <img src="/assets/media/logo-exn.png" />
                  <h1 className="text-gray-500 fw-bolder mb-3 mt-6">
                    {t("auth.forgotPassword")}
                  </h1>
                </div>

                {error != null && <p className="text-danger">{error}</p>}

                <div className="fv-row mb-8">
                  <input
                    type="text"
                    placeholder={t("users.email")}
                    name="email"
                    autoComplete="off"
                    defaultValue={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={step2}
                    className="form-control bg-transparent"
                  />
                </div>
                {step2 && (
                  <>
                    <div className="fv-row mb-8">
                      <input
                        placeholder={t("auth.verificationCode")}
                        name="code2fa"
                        autoComplete="off"
                        type="text"
                        id="recoveryCode_form"
                        value={recoveryCode}
                        onChange={(e) => setRecoveryCode(e.target.value)}
                        className="form-control bg-transparent"
                      />
                    </div>

                    <div className="fv-row mb-8">
                      <input
                        type="password"
                        placeholder={t("auth.password")}
                        name="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="off"
                        className="form-control bg-transparent"
                      />
                    </div>
                  </>
                )}
                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    id="kt_sign_in_submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="indicator-label">
                        {t("auth.sending")}
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : !step2 ? (
                      <span className="indicator-label">
                        {t("auth.sendRecoveryCode")}
                      </span>
                    ) : (
                      <span className="indicator-label">
                        {t("auth.createNewPassword")}
                      </span>
                    )}
                  </button>
                </div>
                <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                  <NavLink to={"/"} className="link-primary">
                    {t("auth.backToLogin")}
                  </NavLink>
                </div>
                <div className="text-gray-500 text-center fw-semibold fs-6 d-none">
                  {t("auth.noAccount")}&nbsp;
                  <a
                    href="authentication/layouts/corporate/sign-up.html"
                    className="link-primary"
                  >
                    {t("auth.register")}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PasswordRecovery;
